import React, { useContext, useState, useEffect, forwardRef, useImperativeHandle} from 'react';
import Radio from '@material-ui/core/Radio';
import { makeStyles } from '@material-ui/core/styles';
import RadioGroup from '@material-ui/core/RadioGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import FormControl from '@material-ui/core/FormControl';
import FormLabel from '@material-ui/core/FormLabel';
import { GlobalTheme } from '../../layouts/theme';
import { Theme } from '../contexts/themeContext.js';
import { HttpService } from '../../apiAuthorization/httpService';
import KeyboardReturnIcon from '@material-ui/icons/KeyboardReturn';
import Grid from '@material-ui/core/Grid';
import HistoryIcon from '@material-ui/icons/History';
import MaterialTable, { MTableToolbar } from 'material-table';

const useStyles = makeStyles(theme => ({
    root: {
        '& > *': {
            margin: '7px 0px',
            width: '100%'
        }
    },
    button: {
        width: '15%',
        float: 'right'
    },
    formControl: {
        margin: theme.spacing(1),
        minWidth: 120,
        maxWidth: 300
    },
    backdrop: {
        zIndex: theme.zIndex.drawer + 1,
        color: '#fff'
    },
    mb10: {
        marginBottom: "10px"
    },
    mb5: {
        marginBottom: "5px"
    }
}));

const PatientFellAdd = forwardRef((props, ref) => {
    const classes = useStyles();
    const { theme } = useContext(Theme);
    const { patientSittingDto, close, onDisableWithStyle, onHidePatientFellConfirm} = props;
    const currentTheme = theme ? (GlobalTheme[theme]) : (GlobalTheme[localStorage.getItem("theme")]);

    const [patientFellDto, setPatientFellDto] = useState([]);
    const [showPatientFellHistory, setShowPatientFellHistory] = useState(false);
    const [patientFellHistorys, setPatientFellHistorys] = useState({
        columns: [
            { field: 'IsPatientFell', title: 'Is Patient Fell', render: rowData => rowData.IsPatientFell ?"Yes":"No"  },
            { field: 'InjuryDescription', title: 'Reason' },
            { field: 'CreatedDateTimeString', title: 'Date', width: '25%' }
        ],
        data: []
    });

    const rowStyle = (rowData, rowIndex) => {
        return { backgroundColor: rowIndex % 2 === 0 ? '' : currentTheme.alternateGridRow };
    };

    const SavePatientFellRecord = () => {

        var _patientFellDto = patientFellDto;
        _patientFellDto.IsPatientFell = _patientFellDto.IsPatientFell === "1" ? true : false;
        _patientFellDto.IsInjured = (_patientFellDto.InjuryDescription && _patientFellDto.InjuryDescription !== "") ? true : false;

        HttpService.post('/PatientSitting/SavePOSPatientFells',
             _patientFellDto
        )
            .then((result) => {
                close();
            },
                (error) => {
                      //This is intentional
                });
    };

    const getPatientFellHistorys = () => {
        HttpService.post('/PatientSitting/GetPOSPatientFells',
            { AppPatientSittingId: patientSittingDto.Id }
        )
            .then((result) => {
                setPatientFellHistorys({ ...patientFellHistorys, data: result.data });
            },
                (error) => {
                      //This is intentional
                });
    };

    useImperativeHandle(ref, () => {
        return {
            save: SavePatientFellRecord,

        };
    });


    useEffect(() => {
        getPatientFellHistorys();
        setPatientFellDto({ ...patientFellDto, AppPatientSittingId: patientSittingDto.Id, IsDeleted: false });
        //eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);


    useEffect(() => {
        
        if (patientFellDto.IsPatientFell === "1") {
            
            onHidePatientFellConfirm(false);

            if (patientFellDto.InjuryDescription && patientFellDto.InjuryDescription !=="") {
                onDisableWithStyle(false);
            }
        }
        else {
            onDisableWithStyle(true);
            onHidePatientFellConfirm(true);
        }
        //eslint-disable-next-line react-hooks/exhaustive-deps
    }, [patientFellDto]);

    return (
        <div>
            {
                patientFellHistorys.data.length > 0
                &&
                <Grid container
                    direction="row"
                    justify="flex-end"
                    alignItems="flex-start"
                    className={classes.mb5}
                    spacing={2}
                >
                    <Grid item>
                        {!showPatientFellHistory && <HistoryIcon fontSize="large" style={{ color: currentTheme.secondary, cursor: 'pointer' }} onClick={() => { onHidePatientFellConfirm(true); setShowPatientFellHistory(true); }} />}
                        {showPatientFellHistory && <KeyboardReturnIcon fontSize="large" style={{ color: currentTheme.secondary, cursor: 'pointer' }} onClick={() => { setShowPatientFellHistory(false); if (patientFellDto.IsPatientFell === "1") { onHidePatientFellConfirm(false); }}} />}
                    </Grid>
                </Grid>
            }
           
            {
                !showPatientFellHistory
                &&
                <>
                    <FormControl component="fieldset">
                        <FormLabel component="legend" style={{ color: currentTheme.text, fontWeight: 'bold', textTransform: 'none' }}>Did the patient fall?</FormLabel>
                        <RadioGroup
                            aria-label="position"
                            name="position"
                            value={patientFellDto.IsPatientFell || null}
                            onChange={(e) => { setPatientFellDto({ ...patientFellDto, IsPatientFell: e.target.value }) }}
                            row
                        >
                            <FormControlLabel
                                value="1"
                                control={<Radio style={{ color: currentTheme.secondary }} />}
                                label="Yes"
                                labelPlacement="end"
                                style={{ color: currentTheme.text }}
                            />
                            <FormControlLabel
                                value="0"
                                control={<Radio style={{ color: currentTheme.secondary }} />}
                                label="No"
                                labelPlacement="end"
                                style={{ color: currentTheme.text }}
                            />
                        </RadioGroup>
                    </FormControl>
                    <br />
                    {
                        patientFellDto.IsPatientFell === "1"
                        &&
                        <FormControl component="fieldset">
                            <FormLabel component="legend" style={{ color: currentTheme.text, fontWeight: 'bold', textTransform: 'none' }}>Was the patient injured?</FormLabel>
                            <RadioGroup
                                aria-label="position"
                                name="position"
                                value={patientFellDto.InjuryDescription || null}
                                onChange={(e) => { setPatientFellDto({ ...patientFellDto, InjuryDescription: e.target.value }) }}
                                row
                            >
                                <FormControlLabel
                                    value="No Injury"
                                    control={<Radio style={{ color: currentTheme.secondary }} />}
                                    label="No Injury"
                                    labelPlacement="end"
                                    style={{ color: currentTheme.text }}
                                />
                                <FormControlLabel
                                    value="Minor Injury - Resulted in bruise, abrasion; needs dressing, ice, limb elevation, topical medications, etc."
                                    control={<Radio style={{ color: currentTheme.secondary }} />}
                                    label="Minor Injury - Resulted in bruise, abrasion; needs dressing, ice, limb elevation, topical medications, etc."
                                    labelPlacement="end"
                                    style={{ color: currentTheme.text }}
                                />
                                <FormControlLabel
                                    value="Moderate Injury - Needs suturing, splinting; or caused muscle/joint strain"
                                    control={<Radio style={{ color: currentTheme.secondary }} />}
                                    label="Moderate Injury - Needs suturing, splinting; or caused muscle/joint strain"
                                    labelPlacement="end"
                                    style={{ color: currentTheme.text }}
                                />
                                <FormControlLabel
                                    value="Major Injury - Needs surgery, cast, traction, results in neurological or internal injury"
                                    control={<Radio style={{ color: currentTheme.secondary }} />}
                                    label="Major Injury - Needs surgery, cast, traction, results in neurological or internal injury"
                                    labelPlacement="end"
                                    style={{ color: currentTheme.text }}
                                />
                                <FormControlLabel
                                    value="Death"
                                    control={<Radio style={{ color: currentTheme.secondary }} />}
                                    label="Death"
                                    labelPlacement="end"
                                    style={{ color: currentTheme.text }}
                                />
                            </RadioGroup>
                        </FormControl>
                    }
                </>
            }

            {
                showPatientFellHistory
                &&
                <MaterialTable
                    title=""
                    columns={patientFellHistorys.columns}
                    data={patientFellHistorys.data}
                    components={{
                        Toolbar: (prop) => (
                            <div
                                style={{
                                    height: "0px",
                                }}
                            >
                                <MTableToolbar {...prop} />
                            </div>
                        )
                    }}
                    style={{ backgroundColor: currentTheme.background, border: '1px solid white' }}
                    options={{
                        filtering: false,
                        search: false,
                        paging: false,
                        actionsColumnIndex: -1,
                        minBodyHeight: "55vh", maxBodyHeight: "55vh",
                        headerStyle: {
                            fontWeight: 'bold', color: currentTheme.headerColor, backgroundColor: currentTheme.headerBackground
                        },
                        actionsCellStyle: {
                            color: currentTheme.secondary,
                            hover: 'white'
                        },
                        rowStyle: rowStyle
                    }}
                />
            }
          
        </div>
    );
});


export default PatientFellAdd;